import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=586a4f93&scoped=true&"
import script from "./downloadCenter.vue?vue&type=script&lang=js&"
export * from "./downloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./downloadCenter.vue?vue&type=style&index=0&id=586a4f93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a4f93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586a4f93')) {
      api.createRecord('586a4f93', component.options)
    } else {
      api.reload('586a4f93', component.options)
    }
    module.hot.accept("./downloadCenter.vue?vue&type=template&id=586a4f93&scoped=true&", function () {
      api.rerender('586a4f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/report/downloadCenter/downloadCenter.vue"
export default component.exports